/* eslint no-undef: 'off' */
import $ from 'jquery';

const faq_add_to_cart = () => {
    $(document).on("click", '.faq_add_to_cart', (event) => {
        const product_id = $(event.target).data("product_id");
        const ajax = themeObj.ajax_faq_add_to_cart;

        let data = {
            nonce: ajax.nonce,
            action: ajax.action,
            product_id: product_id,
        };

        $.ajax({
            type: 'POST',
            url: themeObj.ajaxUrl,
            data: data,
        }).done((res) => {
            if (res.success) {
                alert(res.data.message);
                location.href = res.data.redirect_to;
            } else {
                alert(res.data.message);
            }
        })
    })
}

const init = () => {
    faq_add_to_cart();
}

try {
    init();
} catch (error) {
    // eslint-disable-next-line no-console
    console.log(`This File error ${error}`);
}